import { FC, ReactElement, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Check, NotificationOutline } from '@eqi-investimentos/icons/web';
import { Button, Flex, Spinner, Text } from '@eqi-investimentos/react';
import { salesforceOpportunityConfig } from '@/config/salesForce';
import { useCreateSFOpportunity } from '@/modules/Customer/http/client/mutations/useCreateSFOpportunity';
import { getCookie, setCookie } from '@/utils/cookies';
import { IfRender } from '@/utils/jsx';
export const CTARetirement: FC<CTARetirementProps> = ({
  SimulationElement,
  isWidget = false,
  hasNoData
}) => {
  const {
    t
  } = useTranslation('common');
  const {
    mutate: createSFOpportunity,
    isPending
  } = useCreateSFOpportunity();
  const [isSuccess, setIsSuccess] = useState(() => getCookie(SENT_NORETIREMENT_COOKIE_KEY) === 'true');
  const sendOpportunity = () => {
    createSFOpportunity({
      action: salesforceOpportunityConfig.FP.myRetirement.empty.action,
      product: salesforceOpportunityConfig.FP.myRetirement.empty.product
    }, {
      onSuccess: () => {
        setIsSuccess(true);
        setCookie(SENT_NORETIREMENT_COOKIE_KEY, 'true');
      }
    });
  };
  return <Flex flexDir="column" justifyContent="center" gap={5} p="0" w="full" bgColor="background.brandLight" borderRadius="xs" data-sentry-element="Flex" data-sentry-component="CTARetirement" data-sentry-source-file="index.tsx">
      <NotificationOutline w="32" h="32" color="content.brand" mb={3} data-sentry-element="NotificationOutline" data-sentry-source-file="index.tsx" />
      <Text fontSize="lg" fontWeight="normal" lineHeight="2xl" color="content.primary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
        {t(`screens.financialPlanning.myRetirement.${hasNoData ? 'noData' : 'opportunity'}.title`)}
      </Text>
      <Text fontSize="md" fontWeight="normal" lineHeight="xl" color="content.tertiary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
        {t(`screens.financialPlanning.myRetirement.${hasNoData ? 'noData' : 'opportunity'}.description`)}
      </Text>

      <Flex maxW="32.75rem" gap="5" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <IfRender condition={hasNoData} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">{SimulationElement}</IfRender>
        <IfRender condition={!isWidget} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
          <Button justifyContent="center" w="50%" h="2.75rem" gap={2} fontSize="sm" variant={hasNoData ? 'outline' : 'solid'} onClick={sendOpportunity} isDisabled={isSuccess} _disabled={{
          cursor: 'not-allowed',
          color: 'content.primary',
          opacity: 0.6,
          _hover: {
            border: '1px solid',
            borderColor: 'currentColor'
          }
        }} rightIcon={<>
                {isSuccess && <Check w="4" h="4" />}
                {isPending && <Spinner size="sm" emptyColor="content.alwaysLight" />}
              </>} data-sentry-element="Button" data-sentry-source-file="index.tsx">
            {t(`screens.financialPlanning.myRetirement.opportunity.${isSuccess ? 'opportunitySuccess' : 'opportunityCta'}`)}
          </Button>
        </IfRender>
      </Flex>
    </Flex>;
};
export const SENT_NORETIREMENT_COOKIE_KEY = 'fp-noretirement-sent';
type CTARetirementProps = {
  SimulationElement: ReactElement;
  isWidget?: boolean;
  hasNoData: boolean;
};